import { createSlice } from "@reduxjs/toolkit";

export const SPECIAL_DEPENDENT_KEYS = {
  renal: "Complete Renal Profile",
  liver: "Complete Liver Function Tests",
  thyroid: "Thyroid Profile",
};

const initialState = {
  checkedMap: {
    [SPECIAL_DEPENDENT_KEYS.renal]: false,
    [SPECIAL_DEPENDENT_KEYS.liver]: false,
    [SPECIAL_DEPENDENT_KEYS.thyroid]: false,
  },
};

const specialDependentSlice = createSlice({
  name: "specialDependentSlice",
  initialState,
  reducers: {
    setSpecialDependentChecked: (state, action) => {
      const { name, checked } = action.payload || {};
      if (typeof name !== "string") return;
      state.checkedMap[name] = !!checked;
    },
    resetSpecialDependentChecked: (state) => {
      state.checkedMap = { ...initialState.checkedMap };
    },
  },
});

export const {
  setSpecialDependentChecked,
  resetSpecialDependentChecked,
} = specialDependentSlice.actions;

export default specialDependentSlice.reducer;
